import { forwardRef } from 'react';

export const Input = forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>((props, ref) => (
	<input
		{...props}
		ref={ref}
		className={
			'border px-3 py-1 text-lg skin-bg-input skin-border-input skin-text-input skin-rounded-md read-only:opacity-50 ' +
			(props.className ?? '')
		}
	/>
));
